<template>
  <v-dialog persistent v-model="dialog" width="400">
    <v-card>
      <v-card-title class="title"
        >Para prosseguir, o projeto deve ser<br />salvo. Deseja salvar o
        projeto?</v-card-title
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" text @click="closeDialog">Não</v-btn>
        <v-btn color="secondary" text @click="saveConfirm">Sim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogChild: {
      required: true,
      type: Boolean,
    },
  },

  data: () => ({}),

  computed: {
    dialog() {
      return this.dialogChild;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeChild');
    },

    saveConfirm() {
      this.$emit('confirmChild');
    },
  },
};
</script>
